export type AppDateFormats = 'MM/DD/YYYY' | 'DD.MM.YYYY' | 'YYYY-MM-DD' | 'DD/MM/YYYY'
export type AppDateWithTimeFormats = `${AppDateFormats} HH:mm:ss`

export const DEFAULT_SYSTEM_FORMAT_DAY_PICKER = 'YYYY-MM-DD'
export const DEFAULT_SYSTEM_FORMAT_DAY_WITH_TIME = 'YYYY-MM-DD HH:mm:ss'

export const DEFAULT_APP_DATE_FORMAT = 'MM/DD/YYYY'
export const DEFAULT_APP_DATE_WITH_TIME_FORMAT = 'MM/DD/YYYY HH:mm:ss'
export const DEFAULT_APP_TIME_FORMAT = 'HH:mm:ss'

export const DateTimeFormatStrings = {
    MM_DD_YYYY_SLASH :'MM/DD/YYYY',
    DD_MM_YYYY_DOTTED : 'DD.MM.YYYY',  
    YYYY_MM_DD_DASHED : 'YYYY-MM-DD',
    DD_MM_YYYY_SLASH : 'DD/MM/YYYY',
    DEFAULT_APP_DATE_FORMAT : `DD/MM/YYYY`,
    DEFAULT_SYSTEM_FORMAT_DAY_PICKER : 'YYYY-MM-DD',
    DEFAULT_APP_DATE_WITH_TIME_FORMAT : 'MM/DD/YYYY HH:mm:ss',
    DEFAULT_APP_TIME_FORMAT : 'HH:mm:ss',
    DEFAULT_SYSTEM_FORMAT_DAY_WITH_TIME : 'YYYY-MM-DD HH:mm:ss'
} as const;

